import React, { useState } from "react"
import { Button, Menu, MenuItem, Tooltip } from "@mui/material"
import { CCNLabelContainer, CCNText, InvoiceLink } from "./styles"
import { formatPriceWithRupeeSymbol } from "../../utils/price-formatter"
import { CreditNote } from "../../models/invoice.model"
import { InvoiceExternalLinkIcon } from "./InvoiceExternalLinkIcon"

export const CreditNoteMenu = ({
  creditNotes,
  name,
}: {
  creditNotes: CreditNote[]
  name: string
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const optionsLength = creditNotes?.length ?? 0

  if (optionsLength === 0) {
    return null
  }

  return optionsLength === 1 ? (
    <InvoiceLink
      onClick={() => {
        window.open(creditNotes[0].creditNoteUrl)
      }}
    >
      <CCNLabelContainer>
        <CCNText>
          {creditNotes[0].creditNoteNumber} |{" "}
          {formatPriceWithRupeeSymbol(creditNotes[0].creditsApplied)}
          <InvoiceExternalLinkIcon />
        </CCNText>
      </CCNLabelContainer>
    </InvoiceLink>
  ) : (
    <>
      <Tooltip title="Click to view">
        <Button
          id={`${name}-button`}
          aria-controls={open ? `${name}-menu` : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          sx={{
            color: "#667085",
            padding: 0,
          }}
        >
          {`${optionsLength} ${name}s`}
        </Button>
      </Tooltip>
      <Menu
        id={`${name}-menu`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": `${name}-button`,
        }}
      >
        {creditNotes?.map((option) => {
          return (
            <MenuItem onClick={() => window.open(option.creditNoteUrl)}>
              <InvoiceLink>
                <CCNText>
                  {option.creditNoteNumber} |{" "}
                  {formatPriceWithRupeeSymbol(option.creditsApplied)}{" "}
                  <InvoiceExternalLinkIcon />
                </CCNText>
              </InvoiceLink>
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}
